export default "__VITE_ASSET__CFfBpL58__"